import React, { useEffect, useState } from "react";
import { message, Result } from "antd";
import { useNavigate, useLocation } from "react-router-dom";

import { updateOrCreateMercadoPagoCredentialsRequest } from "../api/updateOrCreateMercadoPagoCredentialsRequest";
import "./UpdateOrCreateMercadoPagoCredentials.css";

export const UpdateOrCreateMercadoPagoCredentials = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const params = {
    code: queryParams.get("code"),
    alias: queryParams.get("alias"),
    countryCode: queryParams.get("countryCode"),
  };
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!params.code || !params.alias || !params.countryCode) {
      navigate("/mercadopago/link/rebillError");
      return;
    }
  
    updateOrCreateMercadoPagoCredentialsRequest(
      params.code,
      params.countryCode,
      params.alias
    )
      .then((response) => {
        if (response) {
        setSuccess(true);
          const seconds = 2;
          message.success(`Será redirigido en ${seconds} segundos...`);
          setTimeout(() => {
        window.location.href = "https://dashboard.rebill.to/";
      }, 1000 * seconds);
          return;
        } else {
        navigate("/mercadopago/link/rebillError");
          return;
        }
      })
      .catch((errorInfo) => {
        navigate("/mercadopago/link/rebillError");
        return;
      });
  }, []);

  if (success) {
    return (
      <Result
        status="success"
        title="Credenciales generadas exitosamente."
        subTitle="Aguade unos segundos que será redirigido."
      />
    );
  }
  return (
    <div className="processing-page">
      <div className="loader"></div>
      <p>Aguárdanos un momento mientras procesamos la información...</p>
    </div>
  );
};
